import Fetcher from 'libs/fetcher';

const fetcher = new Fetcher();

export const getAges = async () => fetcher.get({ path: '/ages' });
